module.exports = __webpack_public_path__ + "img/remarks-dp.c079566f.svg";